import React from 'react';
import Anavbar from '../components/JSX/Anavbar';
import Footera from '../components/JSX/Footera';
import Slider2 from '../components/JSX/Slider2';
import Story from '../components/JSX/Story';
import Mission from '../components/JSX/Mission';
import Credentials from '../components/JSX/Credentials';
import Team from '../components/JSX/Team';
import Our from '../components/JSX/Our';

const About = () => (
  <>
    <Anavbar/>
    <Slider2 />
    <Story />
    <Mission />
    <Credentials/>
    <Team/>
    <Our/>
    <Footera />
  </>
);

export default About;